import CardsPage from "../../components/CardsPage/CardsPage";
import { items } from "../../data/routes";

const B2BStore = () => {
  return (
    <CardsPage
      items={items.find((item) => item.title === "B2B Store").childrens}
    />
  );
};

export default B2BStore;
